"use client";

import Category2BoldIcon from "@/app/_components/Icons/Category2BoldIcon";
import Category2Icon from "@/app/_components/Icons/Category2Icon";
import HomeBoldIcon from "@/app/_components/Icons/HomeBoldIcon";
import HomeIcon from "@/app/_components/Icons/HomeIcon";
import ShoppingBagBoldIcon from "@/app/_components/Icons/ShoppingBagBoldIcon";
import ShoppingBagIcon from "@/app/_components/Icons/ShoppingBagIcon";
import UserBoldIcon from "@/app/_components/Icons/UserboldIcon";
import UserIcon from "@/app/_components/Icons/UserIcon";
import { useBreakPoints } from "@/lib/useBreakPoints";
import {
  Badge,
  BadgeProps,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Button,
  Collapse,
  Icon,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import React, { ReactNode, useEffect, useState } from "react";
import NextLink from "next/link";
import { usePathname } from "next/navigation";
import { useCart } from "@/redux/features/cart/hooks";
import BottomButton from "@/app/(main)/_components/BottomButton";
import BottomBarCategories from "@/app/(main)/_components/BottomBarCategories";
import BottomBarProfile from "../BottomBarProfile";
import { useBottomBar } from "./BottomBarProvider";

export default function BottomBar() {
  const { state } = useBottomBar();
  const { mdAndUp } = useBreakPoints();
  const { itemsCount } = useCart();
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  const isCartPage = pathname === "/cart";
  const isProfilePage = pathname.startsWith("/profile");
  const [badgeClass, setBadgeClass] = useState("");

  useEffect(() => {
    setBadgeClass("badge-animation");

    const timer = setTimeout(() => {
      setBadgeClass("");
    }, 300); // Duration should match CSS animation duration

    return () => clearTimeout(timer);
  }, [itemsCount]);

  if (mdAndUp) {
    return <></>;
  }

  return (
    <>
      <Paper
        sx={{
          display: {
            xs: "block",
            md: "none",
          },
          zIndex: 3,
          transition: "0.2s all ",
          background: "linear-gradient(to top, #fff 70%,transparent )",
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          //   pb: 1,
          ...(!state.attach && { px: 1, pb: 1.5 }),
          borderRadius: 0,
        }}
        elevation={0}
      >
        <Collapse in={Boolean(state.content)}>{state.content}</Collapse>
        <Box
          sx={{
            borderRadius: 0,
            ...(!state.attach && { borderRadius: 100 }),
            transition: "0.3s all ",
            backgroundColor: "grey.800",
            height: 48,
            overflow: "hidden",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            px: { xs: 0.8, md: 1 },
            overflowX: "auto",
          }}
          className={"custom-scrollbar"}
        >
          <BottomButton selected={isHomePage} label="خانه" icon={<HomeIcon />} boldIcon={<HomeBoldIcon />} href={"/"} />
          <BottomBarCategories />
          <BottomButton
            selected={isCartPage}
            label="سبد خرید"
            className={badgeClass}
            icon={<ShoppingBagIcon />}
            boldIcon={<ShoppingBagBoldIcon />}
            href={"/cart"}
            badge={itemsCount || undefined}
          />
          <BottomBarProfile />
        </Box>
      </Paper>
    </>
  );
}
